import { ExecuteJavascriptWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ExecuteJavascript')
export class ExecuteJavascriptNodeSchemaProvider extends SchemaProvider<ExecuteJavascriptWorkflowNode> {}
